import React from 'react';

import { Fade, Paper } from '@mui/material';

export interface IOrderDetailsSection {
  title?: string;
  children: any;
}

function OrderDetailsSection(props: IOrderDetailsSection) {
  const { children, title } = props;
  return (
    <Fade in style={{ transitionDelay: '200ms' }}>
      <Paper>
        {title && (
          <div className='title-bar'>
            <div>{title}</div>
          </div>
        )}
        {children}
      </Paper>
    </Fade>
  );
}

export default OrderDetailsSection;
